import { FuelFlex } from '@frete.com/fuel-station-react';
import ExposedTruckerProfileSkeleton from 'exposed-profile-skeleton';
import LazyProfileDrawer from 'lazy-profile-drawer';
import OpenSearch from 'open-search';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { TruckerProfile } from 'trucker-profile';

const MockedContext: FC = () => (
  <Outlet
    context={{
      freight: { code: 'SPGO-0001' },
      truckerId: 'PWE',
      showDepositInfo: false,
    }}
  />
);

export const localRoutes = [
  { path: '', element: <MockedContext />, children: [{ path: '', element: <TruckerProfile /> }] },
  {
    path: '/search',
    element: <MockedContext />,
    children: [
      {
        path: '',
        element: (
          <FuelFlex defaultProps={{ padding: 'km3' }}>
            <OpenSearch />
          </FuelFlex>
        ),
      },
    ],
  },
  {
    path: '/profile-drawer',
    element: (
      <>
        <div id="profile-portal" />
        <LazyProfileDrawer {...{ data: { portalName: 'profile-portal', truckerId: 'PWE' } }} />
      </>
    ),
  },
  { path: '/skeleton', element: <ExposedTruckerProfileSkeleton /> },
];

export default localRoutes;
